module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_306227.8d4e9e61.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetSatF/FormatoSimplificado_306227.pdf
// module id = 337
// module chunks = 0